export default __webpack_public_path__ + "static/Logo_Premium-Partner-2Sterne-2024-424a0bab1ba3100b01fb1343c9ef58d6.png";